import PageShell from "@/components/primitives/PageShell";
import BecomeReseller from "./Screen/becomeReseller";

export default function Revenda() {
  return (
    <PageShell navbar="flow">
      <BecomeReseller />
    </PageShell>
  );
}
